module.exports = __webpack_public_path__ + "img/sppr_gnss.a5198b23.jpg";